import * as React from 'react'
import * as Styled from './styled'

import { selectCopyright } from '@src/state/site/selectors'
import { RootState } from '@src/state/types'
import { connect } from 'react-redux'

interface StateProps {
  copyright: string
}

type Props = StateProps
const PRIVACY_POLICY_LINK =
  'https://privacyportal.onetrust.com/webform/a21a74f4-2f93-44a2-a887-302a9213c997/06b040b7-49eb-464a-b19a-ea35c85c79fc'
const ADVERTISE_LINK = 'https://collegemarketing.chegg.com/'

const Footer: React.FunctionComponent<Props> = ({ copyright }) => (
  <Styled.Footer>
    <Styled.Copyright>{copyright}</Styled.Copyright>
    <Styled.LinksContainer>
      <Styled.PrivacyLink href={ADVERTISE_LINK}>Advertise with us</Styled.PrivacyLink>
      <Styled.PrivacyLink href={PRIVACY_POLICY_LINK}>
        Your privacy choices
      </Styled.PrivacyLink>
      <Styled.CCPALink id="ot-sdk-btn" className="ot-sdk-show-settings" href="#">
        DO NOT SELL MY INFO
      </Styled.CCPALink>
    </Styled.LinksContainer>
  </Styled.Footer>
)

const mapStateToProps = (state: RootState): StateProps => ({
  copyright: selectCopyright(state),
})

export default connect<StateProps>(mapStateToProps)(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer/index.tsx